<div class="emptyState">
  <figure><img src="../../../resources/images/errors/genericerror.gif"></figure>
  <div class="emptyState_body">
    <h2>OOPS!!</h2>
    <p>We Can't Seem to find the page you are looking for</p>
    <p>Wanna go to the <a href="/">Home</a> page instead</p>
  </div>
</div>